import { render } from "./Calendar.svg?vue&type=template&id=4b31d2b4"
const script = {}
script.render = render

export default script